import { Model } from './model';

export enum creditType {
  SMS = 'sms',
  EUR = 'eur'
}

export enum smsType {
  GP = 'GP',
  GS = 'GS',
  TI = 'TI',
  SI = 'SI'
}

export enum refillPeriod {
  DAY = 'common_day',
  WEEK = 'common_week',
  MONTH = 'common_month',
  YEAR = 'common_year'
}

export class AutoTopUp extends Model {
  idShopItem: string;
  enabled: boolean;
  creditType: creditType;
  alertLimit: number;
  smsType: smsType;
  idCustShopItem: string;
  maxRefillPerPeriod: number;
  refillPeriod: refillPeriod;
  agreeCheck?: boolean;

  // afterDeserialize(input: any) {
  //   if (input['payment-method-id']) {
  //     this.paymentMethodId = input['payment-method-id'];
  //   }
  //   if (input['payment-method-type']) {
  //     this.paymentMethodType = input['payment-method-type'];
  //   }
  //   if (input['card-number']) {
  //     this.cardNumber = input['card-number'];
  //   }
  //   if (input['card-expire']) {
  //     this.cardExpire = input['card-expire'];
  //   }
  //   if (input['card-brand']) {
  //     this.cardBrand = input['card-brand'];
  //   }
  //   if (input.type && !this.cardBrand) {
  //     this.cardBrand = input.type;
  //   }
  //   if (input['bank-code']) {
  //     this.bankCode = input['bank-code'];
  //   }
  //   if (input['mandate-url']) {
  //     this.mandateUrl = input['mandate-url'];
  //   }
  // }
}
